export function myHash(myString: string) {
  var hash = 0,
    i,
    chr;
  if (myString.length === 0) return hash;
  for (i = 0; i < myString.length; i++) {
    chr = myString.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}
